var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7912 2.58769L18.9979 1.79437L11.6493 9.14302C10.7307 10.0616 9.18579 10.0616 8.26721 9.14302L0.918564 1.83613L0.125244 2.62945L5.59497 8.09917L0.125244 13.5689L0.918564 14.3622L6.38829 8.89249L7.47389 9.97809C8.14195 10.6461 9.01877 11.0219 9.93735 11.0219C10.8559 11.0219 11.7328 10.6461 12.4008 9.97809L13.4864 8.89249L18.9561 14.3622L19.7495 13.5689L14.2797 8.09917L19.7912 2.58769Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2463 15.7818H1.75365C0.793319 15.7818 0 14.9885 0 14.0282V2.25365C0 1.29332 0.793319 0.5 1.75365 0.5H18.2463C19.2067 0.5 20 1.29332 20 2.25365V14.0282C20 14.9885 19.2067 15.7818 18.2463 15.7818ZM1.7119 1.62735C1.37787 1.62735 1.12735 1.87787 1.12735 2.2119V13.9864C1.12735 14.3205 1.37787 14.571 1.7119 14.571H18.2046C18.5386 14.571 18.7891 14.3205 18.7891 13.9864V2.2119C18.7891 1.87787 18.5386 1.62735 18.2046 1.62735H1.7119Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.a06b3907861bb1fef8f3e163bda9b9cb.svg";
export { ForwardRef as ReactComponent };